import { CurrentState } from "../../state/currentState";
import { PastProfile } from "./pastProfileTypes";

/**
 * 현재 상태와 과거 로스팅을 비교하기 위한 feature 벡터
 */
export interface KNNFeatureVector {
  devProgress: number; // tDev / devTime
  deltaBT: number; // currBT - dropBT
  deltaROR: number; // currROR - meanROR
}

/**
 * feature별 거리 가중치 (튜닝 대상)
 */
//가중치 구조
export interface KNNDistanceWeights {
  devProgress: number;
  deltaBT: number;
  deltaROR: number;
}
export const DEFAULT_KNN_WEIGHTS: KNNDistanceWeights = {
  devProgress: 1.0,
  deltaBT: 0.7,
  deltaROR: 0.5,
};
export interface PastProfileFeatureWeights {
  devTime?: number;
  dropBT?: number;
  meanROR?: number;
}
/**
 * 현재 상태와 과거 프로파일을 feature 벡터로 변환
 */
//거리계산
export function knnDistanceWeighted(v: KNNFeatureVector, w: KNNDistanceWeights = DEFAULT_KNN_WEIGHTS): number {
  return w.devProgress * v.devProgress ** 2 + w.deltaBT * (v.deltaBT / 30) ** 2 + w.deltaROR * v.deltaROR ** 2;
}

//PastProfile → Feature Vector 변환
export function buildKNNVector(curr: CurrentState, past: PastProfile): KNNFeatureVector {
  return {
    devProgress: curr.tDev / past.devTime - 0.5,
    deltaBT: curr.BT - past.dropBT,
    deltaROR: curr.ROR - past.meanROR,
  };
}
